'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _video = require('../../constants/events/video');

var _video2 = _interopRequireDefault(_video);

var _ui = require('../../constants/events/ui');

var _ui2 = _interopRequireDefault(_ui);

var _controls = require('./controls.view');

var _controls2 = _interopRequireDefault(_controls);

var _progress = require('./progress/progress.controler');

var _progress2 = _interopRequireDefault(_progress);

var _play = require('./play/play.controler');

var _play2 = _interopRequireDefault(_play);

var _time = require('./time/time.controler');

var _time2 = _interopRequireDefault(_time);

var _volume = require('./volume/volume.controler');

var _volume2 = _interopRequireDefault(_volume);

var _fullScreen = require('./full-screen/full-screen.controler');

var _fullScreen2 = _interopRequireDefault(_fullScreen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_CONFIG = {
  list: [_play2.default, _time2.default, _progress2.default, _volume2.default, _fullScreen2.default],
  view: null
};

var HIDE_CONTROLS_BLOCK_TIMEOUT = 2000;

var ControlBlock = function () {
  function ControlBlock(_ref) {
    var engine = _ref.engine,
        ui = _ref.ui,
        eventEmitter = _ref.eventEmitter,
        config = _ref.config;

    _classCallCheck(this, ControlBlock);

    this._eventEmitter = eventEmitter;
    this._engine = engine;
    this._ui = ui;
    this.config = _extends({}, DEFAULT_CONFIG, config);

    this.isHidden = false;
    this._isVideoPaused = false;
    this._delayedToggleVideoPlaybackTimeout = null;
    this._hideControlsTimeout = null;
    this._isControlsFocused = false;
    this._controls = [];

    this._bindViewCallbacks();
    this._initUI();
    this._initControls();
    this._bindEvents();
  }

  _createClass(ControlBlock, [{
    key: '_initUI',
    value: function _initUI() {
      var view = this.config.view;

      var config = {
        callbacks: {
          onControlsBlockMouseMove: this._setFocusState,
          onControlsBlockMouseOut: this._removeFocusState
        }
      };
      if (view) {
        this.view = new view(config);
      } else {
        this.view = new this.constructor.View(config);
      }
    }
  }, {
    key: '_initControls',
    value: function _initControls() {
      var _this = this;

      this.config.list.forEach(function (Control) {
        var control = new Control({
          engine: _this._engine,
          eventEmitter: _this._eventEmitter
        });

        _this._controls.push(control);
        _this.view.appendControlNode(control.node || control.getNode());
      });
    }
  }, {
    key: '_bindViewCallbacks',
    value: function _bindViewCallbacks() {
      this._startHideControlsTimeout = this._startHideControlsTimeout.bind(this);
      this._setFocusState = this._setFocusState.bind(this);
      this._removeFocusState = this._removeFocusState.bind(this);
      this._showContent = this._showContent.bind(this);
      this._hideContent = this._hideContent.bind(this);
    }
  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      this._eventEmitter.on(_ui2.default.MOUSE_MOVE_ON_PLAYER_TRIGGERED, this._startHideControlsTimeout);
      this._eventEmitter.on(_ui2.default.MOUSE_LEAVE_ON_PLAYER_TRIGGERED, this._hideContent);
      this._eventEmitter.on(_ui2.default.ENGINE_CONTROL_THROUGH_KEYBOARD_TRIGGERED, this._startHideControlsTimeout);

      this._eventEmitter.on(_video2.default.STATE_CHANGED, this._updatePlayingStatus, this);
    }
  }, {
    key: '_startHideControlsTimeout',
    value: function _startHideControlsTimeout() {
      this._stopHideControlsTimeout();

      this._showContent();

      if (!this._isControlsFocused) {
        this._hideControlsTimeout = setTimeout(this._hideContent, HIDE_CONTROLS_BLOCK_TIMEOUT);
      }
    }
  }, {
    key: '_stopHideControlsTimeout',
    value: function _stopHideControlsTimeout() {
      if (this._hideControlsTimeout) {
        clearTimeout(this._hideControlsTimeout);
      }
    }
  }, {
    key: '_setFocusState',
    value: function _setFocusState() {
      this._isControlsFocused = true;
    }
  }, {
    key: '_removeFocusState',
    value: function _removeFocusState() {
      this._isControlsFocused = false;
    }
  }, {
    key: '_showContent',
    value: function _showContent() {
      this._eventEmitter.emit(_ui2.default.CONTROL_BLOCK_SHOW_TRIGGERED);

      this.view.showControlsBlock();
    }
  }, {
    key: '_hideContent',
    value: function _hideContent() {
      if (!this._isVideoPaused) {
        this._eventEmitter.emit(_ui2.default.CONTROL_BLOCK_HIDE_TRIGGERED);

        this.view.hideControlsBlock();
      }
    }
  }, {
    key: '_updatePlayingStatus',
    value: function _updatePlayingStatus(_ref2) {
      var nextState = _ref2.nextState;

      if (nextState === this._engine.STATES.PLAY_REQUESTED) {
        this._isVideoPaused = false;
        this._startHideControlsTimeout();
      } else if (nextState === this._engine.STATES.ENDED) {
        this._isVideoPaused = false;
        this._hideContent();
      } else if (nextState === this._engine.STATES.PAUSED) {
        this._isVideoPaused = true;
        this._showContent();
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.isHidden = true;
      this.view.hide();
    }
  }, {
    key: 'show',
    value: function show() {
      this.isHidden = false;
      this.view.show();
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this._eventEmitter.off(_ui2.default.MOUSE_MOVE_ON_PLAYER_TRIGGERED, this._startHideControlsTimeout);
      this._eventEmitter.off(_ui2.default.MOUSE_LEAVE_ON_PLAYER_TRIGGERED, this._hideContent);
      this._eventEmitter.off(_ui2.default.ENGINE_CONTROL_THROUGH_KEYBOARD_TRIGGERED, this._startHideControlsTimeout);

      this._eventEmitter.off(_video2.default.STATE_CHANGED, this._updatePlayingStatus, this);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._stopHideControlsTimeout();
      this._unbindEvents();
      this.view.destroy();
      delete this.view;

      this._controls.forEach(function (control) {
        return control.destroy();
      });
      delete this._controls;

      delete this._eventEmitter;
      delete this._engine;
      delete this._ui;
      delete this.config;

      this.isHidden = null;
      this._isVideoPaused = null;
      this._hideControlsTimeout = null;
      this._isControlsFocused = null;
      this._delayedToggleVideoPlaybackTimeout = null;
    }
  }, {
    key: 'node',
    get: function get() {
      return this.view.getNode();
    }
  }]);

  return ControlBlock;
}();

ControlBlock.View = _controls2.default;
exports.default = ControlBlock;
//# sourceMappingURL=controls.controler.js.map



//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/ui/controls/controls.controler.js
// module id = 1225
// module chunks = 1 2 3